module.exports = __webpack_public_path__ + "static/media/fondo_contact.c58142e3.jpg";